<template>
	<div class="measure-pedometer">
		<div class="date-time">
			<span class="date">{{ date(value.datetime) }}</span>
			<span class="time">{{ time(value.datetime) }}</span>
		</div>
		<div class="value"><span>{{ value.values.value }}</span> {{ $t('labels.general.steps') }}</div>
		<div class="svg">
			<d3-generic :value="value.values.value" :icon="'pedometer'" :domain="domain"/>
		</div>
	</div>
</template>

<script>
import D3Generic from '../../../shared/widgets/measure/D3Generic'
export default {
	components: {
		D3Generic
	},
	props: [
		'value'
	],
	data () {
		return {
			domain: {
				min: 0,
				max: 100
			}
		}
	},
	methods: {
		date (date) {
			return this.$moment(date).format('D MMM')
		},
		time (date) {
			return this.$moment(date).format('HH:mm')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/biometric/widgets/measure/MeasurePedometer.vue